module.exports = __webpack_public_path__ + "media/images/groupRank__eval--wrong@3x-4dd486904d093643d0954f4cdb7be563.png";